"use client"

import ProductLabel from "@/components/common/ProductLabel"
import ProductSizeButton from "@/components/common/ProductSizeButton"
import { useSelectedVariant } from "@/hooks/product_no_design/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { Col, Row, Tooltip } from "antd"

const ProductSizes = () => {
  const attributes = useAppSelector(state => state.product.product_no_design?.data?.attributes)
  const variants = useAppSelector(state => state.product.product_no_design?.data?.variants)
  const selectedVariant = useSelectedVariant()
  const sizeSetting = useAppSelector(state => state.store.store_setting.data.sizes_selection)

  const dispatch = useAppDispatch()

  if (!attributes || !attributes?.find(attr => !!attr['size'])) {
    return <></>
  }

  const collectionSizes = variants?.reduce((arr: any[], v) => {
    const attributes = v.attributes || []
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      if (!attr.size) {
        continue
      }
      if (!arr.some((a: any) => a.size === attr.size)) {
        arr.push(attr)
      }
    }
    return arr
  }, []) || []

  return (
    <>
      <Row>
        <ProductLabel labelSetting={sizeSetting.label} />
      </Row>
      <Row gutter={[10, 10]}>
        {collectionSizes.map((attr) => {
          return (
            <Col key={attr.size}>
              <Tooltip
                title={attr.size}
              >
                <ProductSizeButton
                  onClick={() => dispatch(productActions.selectVariantNoDesign({
                    type: "size",
                    value: attr.size
                  }))}
                  shape={"round"}
                  ghost={!variants?.some(v => v.attributes?.some(attr1 => attr1?.size === attr.size) && v.id === selectedVariant.id)}
                >
                  {attr.size}
                </ProductSizeButton>
              </Tooltip>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductSizes